<template>
  <div v-if="product.car_model_details.length" class="car-model-details">
    <h2>{{ $t('applicability') }}</h2>

    <div class="table-applicability">
      <div class="head-table data-table">
        <div>{{ $t('mark') }}</div>
        <div>{{ $t('model') }}</div>
        <div>{{ $t('year_manufacture') }}</div>
        <div>{{ $t('engine') }}</div>
      </div>
      <div class="data-table" v-for="detail in product.car_model_details">
        <div>{{ detail.model.mark.name }}</div>
        <div>{{ detail.model.name }}</div>
        <div>
          <template v-if="detail.date_start">
            {{ detail.date_start }} - {{ detail.date_end ? detail.date_end : 'н.в.' }}
          </template>
        </div>
        <div>
          {{ detail.engine }}
          <template v-if="detail.power_kw">| {{ detail.power_kw }} kW</template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['product'],
}
</script>
